/**
 * Created by wx on 2018/5/24.
 * 这部分前后端公用，请保持UMD模式
 */
const internalEmailReg = new RegExp('^[A-Za-z0-9._%+-]+@patsnap.com|@zhihuiya.com$');

const automationUserIdSets = new Set([
	// CN
	'69f133893256499e8caa2dc594b21c5f',
	'35b8384a609940c0b507bc9fbaebc682',
	'bd3ba61e1e554b798e44d358ce28f7de',
	'0fd42425e3fd48189e8d204030abca55',
	'736ef79943a54bb8a30c082b8da7c4bc',
	'cc4b84234ba94ec0bc7950fa7816d2fa',
	'42b18fbff6324defa494c621c8f3f5d2',
	'2b24779ceb89481595c653132397076b',
	'27810',
	'52246',
	'28683',
	//US
	'2a69ded92961414e87a40a00949247c5',
	'2b24779ceb89481595c653132397076b',
	'27810',
	'52246',
	'28683',


	// QA
	'402e2e50e02d45299c3c845a25334b23',
	'272f342c5851443b89e89d416fd00910',
	'964feefef530498b9d26b2a657c0f87e',
	'afb010d93f0e4fb2aabea855ec4e953d',
	'8e91c4ad2b0f4fada2ad0f4fdae6b4e2',
	'bd860a0530324cdb82ae72ff571a6dbb',
	'bbb8be4f4d4c4925827dd95cbe835dee',
	'6c8baf37dc8c45beb93366d2406641c5',
	'160b8142a08c4513a063cec995522b64',
	'c98a7ee1e6314adfb9f487e2fb3c5e84',
	'c6c10ffea3ef4a55add12c6485883901',
	'dec52df15fe84f27aad2e4ebc31fb5f2',
	'8e7fa427b0ea4f45b45ce32650fdf99e',
	'ab81010867994447beda65701a0c0ead',
	'd34ba2f8c9974d79a4ae37d981fabff1',
	'61a1198ca1bc4a8fa698438e0b11ed6c',
	'78cf1d90a28a42f49103e6900323924b',
	'd54a2488d77b424dbc426c5d609ec992',
	'594b5d4c3c644415a2a572c484fe7c7f',
	'5e52767103e3423e85c8b4e57dcfb9eb',
	'ac169cfa22cd41c39ea5e9ccfb69eb9e',
	'e4b374d8e1bf47e5938207f85cfbc760',
	'05e58ce73e124faabc3e0684e1cc701d',
	'6bdb193248c7483b8b5bf5ef36f5495c',
	'0fa413d490204d208a30891b871ee9db',
	'44281fbd5642402489b867ae16c01609',
	'0fde029ea019416cbb44e76633c3b9fb',
	'16f0ff6f87b144ef8240e4dc8f69e51c',
	'054c1bdf8b3c419eaf5a7afeaca99ea1',
	'2fb6dfe25f7748869bca237ffb13a575',
	'55d336cfba4d4556ae0a22b11fad13e7',
	'0ec2f5b02ab54e68a81d39f51dd49498',
	'f59ec0ac2cf54027b09d1b12a9fc10a8',
	'429c1d485c534d31ab4ab59cb9a9181b',
	'6685a50a3bfc42418f2fb66001ddc37b',
	'97d37c8e07804977978b3ce702ac766f',


])


export {internalEmailReg, automationUserIdSets}










